export default __webpack_public_path__ + "static/media/logo_gray.ec0b8be4.svg";